import { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FaChevronLeft } from 'react-icons/fa'

import { Box, Button, Dialog, Grid, Tooltip, useTheme } from '@mui/material'
import { Add } from '@mui/icons-material'

import { useGET_groupCourseSessionBehaviourQuery, usePOST_groupCourseSessionBehaviourMutation } from 'redux/api/sessionsApi'
import { useGET_studentsQuery } from 'redux/api/studentsApi'

import { Form, Formik } from 'formik'

import SubmitButton from 'components/atoms/buttons/SubmitButton'
import SessionBehaviourItemList from 'components/molecules/SessionBehaviourItemList'

import { useErrorAlert } from 'utils/customHooks/useErrorAlert'
import { useSuccessAlert } from 'utils/customHooks/useSuccessAlert'
import formModel, { validationSchema } from 'utils/formModels/sessionBehaviourModel'
import { crudColorMap, crudIconMap, parseDateTime}  from 'utils/helpers'

import { ISession } from 'types'
import { format } from 'date-fns'

interface IProps {
  session: ISession
  viewOnly: boolean
  tabText?: string
  tabKey?: string
}


const SessionBehaviourForm: FC<IProps> = ({ session, viewOnly }) => {
  const { t } = useTranslation()

  const [saveBehaviour, {isLoading, isSuccess, error}] = usePOST_groupCourseSessionBehaviourMutation()
  useErrorAlert(error)
  useSuccessAlert(isSuccess ? `${t('alerts.entity-saved', {entity: 'Behaviour incident'})}` : '')

  const [showList, setShowList] = useState(true)


  const { items } = formModel()
  const action = 'edit'

  let filtersStudents = {
    group_course: session.group_course.id,
    page: 1,
    page_size: 999
  }
  const { data: studentsData, refetch: refetchStudents, isLoading: loadingStudents } = useGET_studentsQuery(filtersStudents)
  const { data: behaviourData, refetch: refetchData, isLoading: loadingData } = useGET_groupCourseSessionBehaviourQuery(session.id)

  const isReady = !(isLoading || loadingStudents || loadingData) && showList

  useEffect(() => {
    if (session.id) {
      setShowList(false)
      refetchStudents()
      refetchData()

      setTimeout(() => {
        setShowList(true)
      },200)
      
    }
  }, [session.id])

  const title = session && session?.group && session?.course ? `${format(parseDateTime(session?.start_datetime), 'dd-MM-yyyy HH:ii')} - ${t('common.group')} ${session?.group} - ${session?.course}` : ''

  return ( <>
    { studentsData && behaviourData &&
        <Formik
          enableReinitialize
          initialValues={
            { 
              items: 
                studentsData.results.map(student => { 
                  return {
                    student_id: student.student_profile_id,
                    student_name: student.full_name,
                    ...behaviourData.results.find(item => item.student_id === student.student_profile_id)
                  }
                }) 
            }
          }
          validationSchema={validationSchema}
          onSubmit={(values) => {
            const data = values.items.filter(item => item.incident_level || item.comment).map(item => { return {
              student_id: item.student_id,
              incident_level: item.incident_level || 0,
              comment: item.comment || ''
            }})

            saveBehaviour({id:session.id, body: data});
          }}
        >
          <Form>
            <Grid container spacing={4}>

              <Grid item xs={12} lg={12}>
                {isReady && <SessionBehaviourItemList fieldProps={{ ...items }}  title={title}/>}
              </Grid>    

              <Grid item xs={12} lg={9}>
                <b>Incident level determination guide:</b><div style={{ height: '10px' }} />
                From 1 to 30 mark <b>Disturbing Behaviour</b>  for cases like  Chatting with classmates; Making noise; Throwing objects in the classroom.<div style={{ height: '10px' }} />
                From 31 to 50 mark <b>Unacceptable Behaviour</b> for cases like  Verbal violence; Material damage; Bullying.<div style={{ height: '10px' }} />
                From 51 to 100 mark <b>Bad Behaviour</b> for cases like Chatting with classmates; Making noise; Throwing objects in the classroom.
              </Grid>

              <Grid item xs={12} lg={3} sx={{ textAlign: 'right'}}>
                <SubmitButton
                  color={crudColorMap[action]}
                  text={`${t('form-actions.' + action)}`}
                  icon={crudIconMap[action]}
                  sx={{ width: '10rem' }}
                  isLoading={isLoading}
                />
              </Grid>
            </Grid>
          </Form>
        </Formik>
    }
    </>
  )
}
export default SessionBehaviourForm
